import React, { FC, useContext } from "react";
import { defineMessages, IntlContext } from "react-intl";
import acknowledgements from "@etc/acknowledgements.json";
import "./billingContactUs.scss";

const messages = defineMessages({
  billingContactUs: {
    id: "billingContactUs",
    defaultMessage: "Contact Us",
  },
  billingContactUsNeedHelp: {
    id: "billingContactUsNeedHelp",
    defaultMessage: "Need help? {contactUs}",
  },
});

const BillingContactUs: FC = () => {
  const intl = useContext(IntlContext);

  return (
    <div className="billing-contact-us" data-testid="contactUsHelpText">
      {intl.formatMessage(messages.billingContactUsNeedHelp, {
        contactUs: (
          <a
            target="_blank"
            key="contactUs"
            rel="noreferrer"
            href={acknowledgements.links.contactUs}
          >
            {intl.formatMessage(messages.billingContactUs)}
          </a>
        ),
      })}
    </div>
  );
};

export default BillingContactUs;
